import { render, staticRenderFns } from "./ProducedByNorTV.vue?vue&type=template&id=216025b2&scoped=true&"
import script from "./ProducedByNorTV.vue?vue&type=script&lang=js&"
export * from "./ProducedByNorTV.vue?vue&type=script&lang=js&"
import style0 from "./ProducedByNorTV.vue?vue&type=style&index=0&id=216025b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216025b2",
  null
  
)

export default component.exports